import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Public API calls (no auth required)
export const publicApi = {
  getHero: () => axios.get(`${API}/hero`),
  getAbout: () => axios.get(`${API}/about`),
  getServices: () => axios.get(`${API}/services`),
  getProducts: () => axios.get(`${API}/products`),
  getActivePackages: () => axios.get(`${API}/packages/active`),
  getActivePortfolio: () => axios.get(`${API}/portfolio/active`),
  getProcess: () => axios.get(`${API}/process`),
  getActiveTestimonials: () => axios.get(`${API}/testimonials/active`),
  getSettings: () => axios.get(`${API}/settings`),
  submitContact: (data) => axios.post(`${API}/contacts`, data),
  createCheckoutSession: (packageId, originUrl) => 
    axios.post(`${API}/checkout/create-session`, { package_id: packageId, origin_url: originUrl }),
  getCheckoutStatus: (sessionId) => axios.get(`${API}/checkout/status/${sessionId}`),
  seedData: () => axios.post(`${API}/seed`),
};

// Admin API calls (auth required)
export const adminApi = {
  // Dashboard
  getStats: () => axios.get(`${API}/dashboard/stats`),
  
  // Hero
  getHero: () => axios.get(`${API}/hero`),
  updateHero: (data) => axios.put(`${API}/hero`, data),
  
  // About
  getAbout: () => axios.get(`${API}/about`),
  updateAbout: (data) => axios.put(`${API}/about`, data),
  
  // Services
  getServices: () => axios.get(`${API}/services`),
  createService: (data) => axios.post(`${API}/services`, data),
  updateService: (id, data) => axios.put(`${API}/services/${id}`, data),
  deleteService: (id) => axios.delete(`${API}/services/${id}`),
  
  // Products
  getProducts: () => axios.get(`${API}/products`),
  createProduct: (data) => axios.post(`${API}/products`, data),
  updateProduct: (id, data) => axios.put(`${API}/products/${id}`, data),
  deleteProduct: (id) => axios.delete(`${API}/products/${id}`),
  
  // Packages
  getPackages: () => axios.get(`${API}/packages`),
  createPackage: (data) => axios.post(`${API}/packages`, data),
  updatePackage: (id, data) => axios.put(`${API}/packages/${id}`, data),
  deletePackage: (id) => axios.delete(`${API}/packages/${id}`),
  
  // Portfolio
  getPortfolio: () => axios.get(`${API}/portfolio`),
  createPortfolioItem: (data) => axios.post(`${API}/portfolio`, data),
  updatePortfolioItem: (id, data) => axios.put(`${API}/portfolio/${id}`, data),
  deletePortfolioItem: (id) => axios.delete(`${API}/portfolio/${id}`),
  
  // Process
  getProcess: () => axios.get(`${API}/process`),
  createProcessStep: (data) => axios.post(`${API}/process`, data),
  updateProcessStep: (id, data) => axios.put(`${API}/process/${id}`, data),
  deleteProcessStep: (id) => axios.delete(`${API}/process/${id}`),
  
  // Testimonials
  getTestimonials: () => axios.get(`${API}/testimonials`),
  createTestimonial: (data) => axios.post(`${API}/testimonials`, data),
  updateTestimonial: (id, data) => axios.put(`${API}/testimonials/${id}`, data),
  deleteTestimonial: (id) => axios.delete(`${API}/testimonials/${id}`),
  
  // Contacts
  getContacts: () => axios.get(`${API}/contacts`),
  markContactRead: (id) => axios.put(`${API}/contacts/${id}/read`),
  deleteContact: (id) => axios.delete(`${API}/contacts/${id}`),
  
  // Purchases
  getPurchases: () => axios.get(`${API}/purchases`),
  
  // Settings
  getSettings: () => axios.get(`${API}/settings`),
  updateSettings: (data) => axios.put(`${API}/settings`, data),
  testSmtpConnection: () => axios.post(`${API}/settings/test-smtp`),
  sendTestEmail: () => axios.post(`${API}/settings/send-test-email`),
  uploadImage: (file, imageType) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('image_type', imageType);
    return axios.post(`${API}/settings/upload-image?image_type=${imageType}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  },
  deleteImage: (imageType) => axios.delete(`${API}/settings/delete-image/${imageType}`),
  
  // Stripe Management
  getStripeStatus: () => axios.get(`${API}/stripe/status`),
  getStripeSettings: () => axios.get(`${API}/stripe/settings`),
  updateStripeSettings: (data) => axios.put(`${API}/stripe/settings`, data),
  resetStripeSettings: () => axios.delete(`${API}/stripe/settings`),
  testStripeConnection: () => axios.post(`${API}/stripe/test-connection`),
};
